import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';

const useOperationNavItemStyles = makeStyles()(() => ({
  title: {
    flex: 1,
    ...styles.textClamp(2),
  },
  method: {
    flexBasis: '72px',
  },
}));

export default useOperationNavItemStyles;
